import React from "react";
import { useLocation } from "react-router-dom";
import SeoHead from "./SiteSeo";
import SiteLayout from "./SiteLayout";
import { CalendlyLink } from "./SiteHeader";

// Shown when a real page's data fetch fails (not a 404). Deliberately NOT noindex — a transient API hiccup during a
// Googlebot render must never drop the URL from the index. Keeps the canonical and a reload path.
export default function UnavailablePage({ title, description }) {
  const { pathname } = useLocation();
  return (
    <SiteLayout>
      <SeoHead title={title || "Hello Mortgage Team"} description={description || "Independent Alberta mortgage brokers. Clear advice, zero mortgage-speak."} path={pathname} />
      <section className="hero" data-testid="unavailable-page">
        <div className="hero-grid wrap">
          <div>
            <div className="eyebrow">One second</div>
            <h1 style={{ fontSize: "clamp(3rem,5.5vw,5rem)" }}>The numbers are taking a beat.</h1>
            <p>This page didn’t load the way it should. Give it one more try — or skip the screen and talk to a person.</p>
            <div className="actions">
              <button type="button" className="btn" onClick={() => window.location.reload()} data-testid="unavailable-reload">Try again</button>
              <CalendlyLink className="textlink" testId="unavailable-cta">Book a 15-minute call</CalendlyLink>
            </div>
            <div className="micro">Free conversation. Clear answers. Zero mortgage-speak.</div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
